import {
    Drawer,
    DrawerContent,
    DrawerTrigger,
} from "@/components/ui/drawer"
import { Button } from "@/components/ui/button";
import { CompraRapidaPage } from "@/pages/CompraRapida";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Minus, Plus } from "lucide-react";
import { useAuth } from "@/contexts/AuthProvider";
import { useCarrinho } from "@/contexts/CarrinhoProvider";
import { labelPlural } from "@/utils/copyTituloBilhete";

interface CompraRapidaProps {
    onInteract?: () => void;
}

export function CompraRapida({ onInteract }: CompraRapidaProps) {
    const [quantidade, setQuantidade] = useState(1);
    const navigate = useNavigate()
    const { isAuthorized } = useAuth()
    const { addItemSurpresinha, limparCarrinho } = useCarrinho()

    async function handleCompraRapida() {
        if (isAuthorized) {
            await limparCarrinho();
            await addItemSurpresinha(quantidade);
            navigate('/compra/finalizar', { replace: true })
            navigate(0)
        } else {
            navigate('/compra/rapida?qtd=' + quantidade)
        }
    }

    return (
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 m-1">
            <h1 className="text-center text-primary font-semibold text-xl">
                Compra Rápida
            </h1>
            <div className="flex items-center justify-center gap-3">
                <Button
                    disabled={quantidade === 1}
                    onClick={() => {
                        onInteract?.();
                        if (quantidade === 1) {
                            return;
                        }
                        setQuantidade(quantidade - 1)
                    }}
                    size="lg"
                    variant='outline'>
                    <Minus size="20" />
                </Button>
                <span className="flex flex-col select-none justify-center items-center text-primary text-sm font-semibold">
                    <span>{quantidade}</span>
                    <span>{labelPlural()}</span>
                </span>
                <Button
                    disabled={quantidade > 10}
                    onClick={() => {
                        onInteract?.();
                        setQuantidade(quantidade + 1)
                    }}
                    size="lg"
                    variant='outline'>
                    <Plus size="20" />
                </Button>
            </div>

            {
                isAuthorized ? (
                    <div className="flex justify-center items-center">
                        <Button className="w-40 items-center justify-center" onClick={handleCompraRapida} disabled={quantidade === 0} >
                            {
                                quantidade > 0 ? 'Comprar' : 'Selecione a Quantidade'
                            }
                        </Button>
                    </div>) :
                    (
                        <Drawer direction="right">
                            <DrawerTrigger className="flex justify-center items-center" asChild>
                                <Button className="w-40 items-center justify-center" onClick={handleCompraRapida} disabled={quantidade === 0} >
                                    {
                                        quantidade > 0 ? 'Comprar' : 'Selecione a Quantidade'
                                    }
                                </Button>
                            </DrawerTrigger>
                            <DrawerContent className="min-h-[50%]">
                                <CompraRapidaPage />
                            </DrawerContent>
                        </Drawer>
                    )
            }


        </div>
    )
}